import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Check, Lock, ShieldCheck, CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-charcoal text-beige relative scroll-mt-10" data-id="element-153">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-154">
        <FadeIn className="text-center mb-16" data-id="element-155">
          <h2 className="font-heading text-4xl md:text-5xl text-beige-light mb-4" data-id="element-156">
            Elige tu camino de sanación
          </h2>
          <p className="font-body text-beige/70" data-id="element-157">
            Acceso inmediato después del pago.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-158">
          {/* Essential Tier */}
          <FadeIn delay={0.2} data-id="element-159">
            <div className="bg-beige-light text-charcoal p-8 rounded-sm flex flex-col h-full" data-id="element-160">
              <h3 className="font-heading text-2xl mb-2" data-id="element-161">Esencial</h3>
              <p className="font-body text-charcoal/60 text-sm mb-6 pb-6 border-b border-charcoal/10" data-id="element-162">
                Para quienes quieren comenzar el trabajo por su cuenta.
              </p>

              <div className="mb-2" data-id="element-163">
                <span className="text-4xl font-heading font-semibold" data-id="element-164">
                  $19.990
                </span>
                <span className="text-charcoal/60 text-sm" data-id="element-165"> </span>
              </div>
              <p className="font-body text-charcoal/50 text-xs mb-8" data-id="element-166">
                Pago único (pesos argentinos)
              </p>

              <ul className="space-y-4 mb-8 flex-grow" data-id="element-167">
                {['El sistema completo "El Origen de Tus Bloqueos"', 'Guía de mapeo generacional', 'Audios de liberación emocional', 'Acceso de por vida al contenido'].map((item, i) => <li key={i} className="flex items-start" data-id="element-168">
                    <Check className="w-5 h-5 text-sage-dark mr-3 flex-shrink-0 mt-0.5" data-id="element-169" />
                    <span className="font-body text-sm" data-id="element-170">{item}</span>
                  </li>)}
              </ul>

              <Button className="w-full" variant="outline" onClick={e => {
              e.preventDefault();
              alert('¡Gracias! Tu proceso de sanación comienza ahora.');
            }} data-id="element-171">
                Comenzar Mi Sanación
              </Button>
            </div>
          </FadeIn>

          {/* Complete Tier */}
          <FadeIn delay={0.4} data-id="element-172">
            <div className="bg-gradient-to-b from-gold-light to-gold text-charcoal p-8 rounded-sm flex flex-col h-full relative transform md:-translate-y-4 shadow-2xl" data-id="element-173">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-terracotta text-white px-4 py-1 text-xs font-bold tracking-wider uppercase rounded-full" data-id="element-174">
                Más elegido
              </div>

              <h3 className="font-heading text-2xl mb-2" data-id="element-175">Sistema Completo</h3>
              <p className="font-body text-charcoal/70 text-sm mb-6 pb-6 border-b border-charcoal/20" data-id="element-176">
                La experiencia transformacional profunda.
              </p>

              <div className="mb-2" data-id="element-177">
                <span className="text-4xl font-heading font-semibold" data-id="element-178">
                  $25.990
                </span>
                <span className="text-charcoal/70 text-sm" data-id="element-179"> </span>
              </div>
              <p className="font-body text-charcoal/60 text-xs mb-8" data-id="element-180">
                Pago único (pesos argentinos)
              </p>

              <ul className="space-y-4 mb-6 flex-grow" data-id="element-181">
                {['Todo lo incluido en el plan Esencial', 'Sistema completo paso a paso para detectar y liberar patrones', 'Cartas terapéuticas listas para aplicar', 'Meditación avanzada de corte de lazos', 'Plantillas prácticas de integración emocional'].map((item, i) => <li key={i} className="flex items-start" data-id="element-182">
                    <Check className="w-5 h-5 text-terracotta-dark mr-3 flex-shrink-0 mt-0.5" data-id="element-183" />
                    <span className="font-body text-sm font-medium" data-id="element-184">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <p className="font-body text-sm text-charcoal/80 mb-6 italic" data-id="element-185">
                🔥 La opción que eligen quienes realmente quieren dejar de
                repetir el patrón.
              </p>

              <Button className="w-full bg-charcoal text-white hover:bg-black border-none" onClick={e => {
              e.preventDefault();
              alert('¡Gracias! Tu proceso de sanación comienza ahora.');
            }} data-id="element-186">
                Quiero liberarme de verdad →
              </Button>
            </div>
          </FadeIn>
        </div>

        {/* Payment Trust Block */}
        <FadeIn delay={0.6} data-id="element-187">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 mt-14 pt-10 border-t border-beige/10" data-id="element-188">
            <div className="flex items-center gap-2 text-beige/50" data-id="element-189">
              <ShieldCheck className="w-5 h-5" data-id="element-190" />
              <span className="font-body text-xs" data-id="element-191">
                Compra protegida con Mercado Pago
              </span>
            </div>
            <div className="flex items-center gap-2 text-beige/50" data-id="element-192">
              <CreditCard className="w-5 h-5" data-id="element-193" />
              <span className="font-body text-xs" data-id="element-194">
                Tarjeta, débito o transferencia
              </span>
            </div>
            <div className="flex items-center gap-2 text-beige/50" data-id="element-195">
              <Lock className="w-5 h-5" data-id="element-196" />
              <span className="font-body text-xs" data-id="element-197">Encriptación SSL</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}